import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTitle from '../components/PageTitle';
import {
  BackLink,
  LegalBody,
  LegalContainer,
  LegalHeader,
  LegalMeta,
  LegalPage,
  LegalSection,
} from '../components/legal/LegalLayout';

const LAST_UPDATED = '8 July 2026';

const TERMS_SECTION_ORDER = [
  'service',
  'accounts',
  'subscriptions',
  'content',
  'ai',
  'acceptableUse',
  'ip',
  'disclaimer',
  'liability',
  'termination',
  'changes',
  'contact',
] as const;

const TermsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LegalPage>
      <LegalContainer>
        <LegalHeader>
          <BackLink to="/">{t('legal.backToTemplates')}</BackLink>
          <PageTitle>{t('legal.terms.title')}</PageTitle>
          <LegalMeta>{t('legal.lastUpdated', { date: LAST_UPDATED })}</LegalMeta>
        </LegalHeader>

        <LegalBody>
          <LegalSection>
            <p>{t('legal.terms.intro')}</p>
          </LegalSection>

          {TERMS_SECTION_ORDER.map((sectionKey) => {
            if (sectionKey === 'content') {
              return (
                <LegalSection key={sectionKey}>
                  <h2>{t(`legal.terms.sections.${sectionKey}.title`)}</h2>
                  <p>{t(`legal.terms.sections.${sectionKey}.body1`)}</p>
                  <p>{t(`legal.terms.sections.${sectionKey}.body2`)}</p>
                </LegalSection>
              );
            }

            if (sectionKey === 'acceptableUse') {
              const items = t(`legal.terms.sections.${sectionKey}.items`, {
                returnObjects: true,
              }) as string[];
              return (
                <LegalSection key={sectionKey}>
                  <h2>{t(`legal.terms.sections.${sectionKey}.title`)}</h2>
                  <p>{t(`legal.terms.sections.${sectionKey}.intro`)}</p>
                  <ul>
                    {items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </LegalSection>
              );
            }

            if (sectionKey === 'contact') {
              return (
                <LegalSection key={sectionKey}>
                  <h2>{t(`legal.terms.sections.${sectionKey}.title`)}</h2>
                  <p>
                    {t(`legal.terms.sections.${sectionKey}.body`)}{' '}
                    <a href={`mailto:${t(`legal.terms.sections.${sectionKey}.email`)}`}>
                      {t(`legal.terms.sections.${sectionKey}.email`)}
                    </a>
                    .
                  </p>
                </LegalSection>
              );
            }

            return (
              <LegalSection key={sectionKey}>
                <h2>{t(`legal.terms.sections.${sectionKey}.title`)}</h2>
                <p>{t(`legal.terms.sections.${sectionKey}.body`)}</p>
              </LegalSection>
            );
          })}
        </LegalBody>
      </LegalContainer>
    </LegalPage>
  );
};

export default TermsPage;
